import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppPublic from './AppPublic';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppPublic />
  </React.StrictMode>
);

reportWebVitals();
